import {FeatureAppDefinition, FeatureServices, Logger} from '@feature-hub/core';
import {ReactFeatureApp} from '@feature-hub/react';
import React from 'react';
import {TrackingManagerV1} from '@volkswagen-onehub/tracking-service';
import {LocaleServiceV1} from '@volkswagen-onehub/locale-service';
import {FaContentServiceV1} from '@volkswagen-onehub/fa-content-service';
import MaintenanceCompare from './components/maintenance_compare';
import Charts from './components/Charts';
import {AppContext, FeatureAppConfig} from './context/AppContext';
import { VehicleContextProvider } from './context/modules/VehicleContext';

export interface StarterFeatureAppDependencies extends FeatureServices {
  readonly 'locale-service': LocaleServiceV1;
  readonly 'tracking': TrackingManagerV1;
  readonly 'fa-content-service': FaContentServiceV1;
  readonly 's2:logger'?: Logger;
}

export const featureAppDefinition: FeatureAppDefinition<
  ReactFeatureApp,
  StarterFeatureAppDependencies
> = {
  optionalDependencies: {
    featureServices: {
      'locale-service': '^1.1.0',
      'tracking': '^1.0.0',
      'fa-content-service': '^1.0.0',
      's2:logger': '^1.0.0',
    },
  },

  create: ({featureServices, config}) => ({
    render() {
      return (
        <AppContext.Provider value={config as FeatureAppConfig}>
          <VehicleContextProvider>
            <Charts localeService={featureServices['locale-service']} />
            <MaintenanceCompare
              localeService={featureServices['locale-service']}
              trackingService={featureServices.tracking}
              contentService={featureServices['fa-content-service']}
            />
          </VehicleContextProvider>
        </AppContext.Provider>
      );
    },
  }),
};

export default featureAppDefinition;
